import {
  actions as asyncDataFetch,
  actions as dataFetchActions,
  actionTypes as dataFetchActionTypes,
} from '@buffer-mono/async-data-fetch'
import type { Middleware } from '@reduxjs/toolkit'

import type { AppDispatch, RootState } from '~publish/legacy/store'
import { isLegacyAction } from '~publish/legacy/store/isAction'

import { actionTypes as profileActionTypes } from '~publish/legacy/profile-sidebar/reducer'
import { actions as profilesActions } from '~publish/legacy/profiles/reducer'

import { actionTypes } from './reducer'

const middleware: Middleware<object, RootState, AppDispatch> =
  ({ dispatch }) =>
  (next) =>
  (action): void => {
    next(action)
    if (!isLegacyAction(action)) return
    switch (action.type) {
      case profileActionTypes.SELECT_PROFILE:
        dispatch(
          dataFetchActions.fetch({
            name: 'getLinkShortener',
            args: {
              profileId: action.profile.id,
            },
          }),
        )
        break
      case actionTypes.CHANGE_SELECTED_LINK_SHORTENER:
        dispatch(
          asyncDataFetch.fetch({
            name: 'changeLinkShortener',
            args: {
              profileId: action.profileId,
              domain: action.domain,
            },
          }),
        )
        break
      case actionTypes.TOGGLE_INSTAGRAM_REMINDERS:
        dispatch(
          dataFetchActions.fetch({
            name: 'toggleInstagramReminders',
            args: {
              profileId: action.profileId,
              allowReminders: action.allowReminders,
            },
          }),
        )
        break
      case `toggleInstagramReminders_${dataFetchActionTypes.FETCH_SUCCESS}`:
        dispatch(
          profilesActions.fetchSingleProfile({
            profileId: action.args.profileId,
          }),
        )
        break
      default:
        break
    }
  }

export default middleware
